var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.842 3.69a1.643 1.643 0 0 1 1.326-.475l3.183.274a2.943 2.943 0 0 1 1.795.851l10.064 9.936c.949.937 1.305 2.591.241 3.676l-2.12 2.16c-1.067 1.088-2.728.754-3.677-.183L4.59 9.994a2.954 2.954 0 0 1-.876-1.783L3.39 5.023c-.05-.487.101-.975.452-1.332zm4.85 2.028-2.77 2.774c.023.027.047.053.073.078l8.376 8.27 2.777-2.777-8.407-8.3a1.127 1.127 0 0 0-.05-.045z",
    fill: "#fff"
  })));
};
export default SvgPencil;